import { LoginCallback, RequireAuth } from '@data-delivery/okta-auth-react';
import {
  ForbiddenPage,
  NotFoundPage,
  ProtectedRoute,
  PublicLayout,
  SidebarLayout,
  UserInfoPage,
} from '@data-delivery/permission-ui-shared-ui';
import { Navigate, type RouteObject } from 'react-router-dom';
import { AuthWrapper } from '../auth/auth-wrapper';
import { PATHS, WILDCARD } from '../constants/paths';

export const routeDefinitions: RouteObject[] = [
  {
    element: <AuthWrapper />,
    children: [
      { path: PATHS.notAuthorized, element: <ForbiddenPage /> },
      {
        path: PATHS.authCallback,
        element: (
          <LoginCallback
            enableDebugLogs={process.env.NODE_ENV === 'development'}
            enableSecurityValidation={false}
          />
        ),
      },
      {
        path: PATHS.login,
        element: <PublicLayout />,
      },
      {
        element: (
          <RequireAuth>
            <SidebarLayout />
          </RequireAuth>
        ),
        children: [
          { path: PATHS.rootRedirect, element: <Navigate to={PATHS.dashboard} replace /> },
          {
            path: WILDCARD.businessGroups,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-business-groups');
              return {
                Component: () => (
                  <ProtectedRoute resource='businessGroups' action='view'>
                    <mod.BusinessGroupsModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          {
            path: WILDCARD.dashboard,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-dashboard');
              return { Component: mod.DashboardModule };
            },
          },
          { path: '/organizations', element: <>Some Data</> },
          {
            path: WILDCARD.configuration,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-configuration');
              return {
                Component: () => (
                  <ProtectedRoute resource='products' action='view'>
                    <mod.ConfigurationModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          {
            path: WILDCARD.directoryPermissions,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-directory-permissions');
              return {
                Component: () => (
                  <ProtectedRoute resource='directoryPermissions' action='view'>
                    <mod.DirectoryPermissionsModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          {
            path: WILDCARD.contentAccessRoles,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-content-access-roles');
              return {
                Component: () => (
                  <ProtectedRoute resource='contentAccessRoles' action='view'>
                    <mod.ContentAccessRolesModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          {
            path: WILDCARD.retentions,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-retentions');
              return {
                Component: () => (
                  <ProtectedRoute resource='retentions' action='view'>
                    <mod.RetentionsModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          {
            path: WILDCARD.operators,
            async lazy() {
              const mod = await import('@data-delivery/permission-ui-operator-roles');
              return {
                Component: () => (
                  <ProtectedRoute resource='operatorUsers' action='view'>
                    <mod.OperatorsModule />
                  </ProtectedRoute>
                ),
              };
            },
          },
          { path: PATHS.userInfo, element: <UserInfoPage /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
